(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('ListTargetAudienceController', ListTargetAudienceController);

    /** @ngInject */
    function ListTargetAudienceController($uibModalInstance, selectedTarget, TargetAudienceService, $uibModal, toastr, $translate) {
        var vm = this;

        vm.targetAudienceList = [];
        vm.selectedTargetValue = selectedTarget ? selectedTarget.value : null;
        vm.currentDeleted = false;
        vm.emptyListImage = "https://showkase-prod.s3.sa-east-1.amazonaws.com/assets/empty-publics-list-image.svg";

        vm.paginationOptions = {
            page: 0,
            size: 100
        };

        vm.filter = {};

        init();

        function init() {
            getTargetAudiences(vm.paginationOptions, vm.filter);
        }

        vm.close = function () {
            $uibModalInstance.close({
                selectedItem: null,
                currentDeleted: vm.currentDeleted
            });
        };

        function getTargetAudiences(pagination, filter) {
            TargetAudienceService.listAll(pagination, filter).then(function (response) {
                vm.targetAudienceList = mapTargetAudienceList(response.data.items);
                vm.totalTargetAudiences = response.data.total;
            });
        }

        vm.targetAudiencesActions = [
            {
                icon: 'fa fa-eye',
                label: 'campaign.new.public-info.actions.view',
                method: function (item) {
                    vm.actionItemValue = item.value;
                    vm.openViewTargetAudienceMenu();
                }
            }
        ];

        vm.openViewTargetAudienceMenu = function () {
            var selectedItem = vm.targetAudienceList.find(function (item) {
                return item.value === vm.selectedTargetValue;
            });

            $uibModalInstance.close({
                selectedItem: selectedItem || null,
                currentDeleted: false
            });

            return $uibModal.open({
                templateUrl: 'app/admin/campaign/target-audience/create-target-audience/create-target-audience.html',
                controller: 'CreateTargetAudienceController',
                controllerAs: 'vm',
                windowClass: 'alt-side-modal full-screen-modal',
                backdrop: 'static',
                resolve: {

                    targetAudienceId: function () {
                        return vm.actionItemValue;
                    },
                    isViewMode: function () {
                        return true;
                    }
                }
            }).result.then(function (createdItem) {
                vm.reOpenListOfTargetAudienceMenu();
            });
        };

        vm.reOpenListOfTargetAudienceMenu = function () {
            return $uibModal.open({
                templateUrl: 'app/admin/campaign/target-audience/list-target-audience/list-target-audience.html',
                controller: 'ListTargetAudienceController',
                controllerAs: 'vm',
                windowClass: 'alt-side-modal',
                backdrop: 'static',
                resolve: {
                    selectedTarget: function () {
                        return vm.targetAudience;
                    }
                }
            });
        };


        vm.openConfirmDeleteModal = function () {
            document.body.classList.add('top-side-modal-open');
            return $uibModal.open({
                templateUrl: 'app/components/modal/action-confirmation-modal/action-confirmation-modal.html',
                controller: 'ActionConfirmationModalController',
                controllerAs: 'vm',
                windowClass: 'modal-center confirmation-modal top-side-modal',
                windowTopClass: 'center-modal',
                backdrop: 'static',
                resolve: {
                    modalImage: function () {
                        return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/assets/remove-public-modal-image.svg'
                    },
                    modalTitle: function () {
                        return 'campaign.new.public-info.modal.exclude.title'
                    },
                    modalDescription: function () {
                        return 'campaign.new.public-info.modal.exclude.description'
                    },
                    buttonStyle: function () {
                        return 'ERROR'
                    }

                }
            }).result.then(function (confirm) {
                document.body.classList.remove('top-side-modal-open');
                if (confirm) deleteTargetAudience(vm.actionItemValue);
            });
        };

        function deleteTargetAudience(targetAudienceId) {
            TargetAudienceService.deleteTargetAudience(targetAudienceId)
                .then(function () {
                        if (targetAudienceId == vm.selectedTargetValue) {
                            vm.selectedTargetValue = null;
                        }
                        if (selectedTarget && targetAudienceId == selectedTarget.value) {
                            vm.currentDeleted = true;
                        }
                        getTargetAudiences(vm.paginationOptions, vm.filter);
                        toastr.success(
                            $translate.instant("campaign.new.public-info.toast.delete-success")
                        );
                    },
                    function () {
                        toastr.error($translate.instant("campaign.new.public-info.toast.delete-error"));
                    }
                );
        }

        function mapTargetAudienceList(targetAudienceList) {
            var mappedList = [];
            for (var i = 0; i < targetAudienceList.length; i++) {
                var item = targetAudienceList[i];
                mappedList.push({
                    value: item.id,
                    label: item.name,
                    subtitle: ''
                });
            }
            return mappedList;
        }

        vm.chooseCampaign = function () {
            var selectedItem = vm.targetAudienceList.find(function (item) {
                return item.value == vm.selectedTargetValue;
            });

            $uibModalInstance.close({
                selectedItem: selectedItem || null,
                currentDeleted: false
            });
        };
    }
})();
